import { render, staticRenderFns } from "./afterOrder.vue?vue&type=template&id=506007f6&scoped=true&"
import script from "./afterOrder.vue?vue&type=script&lang=js&"
export * from "./afterOrder.vue?vue&type=script&lang=js&"
import style0 from "./afterOrder.vue?vue&type=style&index=0&id=506007f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506007f6",
  null
  
)

export default component.exports